/* GussKönig – Warenkorb-Drawer (14.10.2026)
   1. Lieferdatum (Werktage, ohne Wochenende und bundesweite Feiertage)
   2. Ergänzung per Klick in den Warenkorb (ohne Seiten-Reload)
   3. Tidio: Hinweistext "Chatten Sie mit uns" überall aus */
(() => {
  if (window.__gkCart) return;
  window.__gkCart = true;

  /* ---------- 1. Lieferdatum ---------- */
  const easter = (y) => {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  };
  const holidayCache = {};
  const holidays = (y) => {
    if (holidayCache[y]) return holidayCache[y];
    const e = easter(y);
    const off = (n) => { const d = new Date(e); d.setDate(d.getDate() + n); return d; };
    const list = [new Date(y, 0, 1), off(-2), off(1), new Date(y, 4, 1), off(39), off(50), new Date(y, 9, 3), new Date(y, 11, 25), new Date(y, 11, 26)];
    holidayCache[y] = new Set(list.map((d) => d.toDateString()));
    return holidayCache[y];
  };
  const isBusinessDay = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !holidays(d.getFullYear()).has(d.toDateString());
  const addBusinessDays = (from, n) => {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isBusinessDay(d)) added++; }
    return d;
  };
  const fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });

  const renderDelivery = () => {
    document.querySelectorAll('[data-gk-cart-delivery]').forEach((el) => {
      if (el.dataset.gkDone) return;
      el.dataset.gkDone = '1';
      const now = new Date();
      const min = parseInt(el.dataset.min, 10) || 2;
      const max = Math.max(parseInt(el.dataset.max, 10) || min, min);
      const a = fmt.format(addBusinessDays(now, min));
      const b = fmt.format(addBusinessDays(now, max));
      const t = el.querySelector('[data-gk-cart-delivery-text]');
      if (t) t.innerHTML = min === max ? 'Lieferung am <b>' + a + '</b>' : 'Lieferung zwischen <b>' + a + '</b> und <b>' + b + '</b>';
    });
  };

  /* ---------- 2. Ergänzung hinzufügen ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-gk-upsell]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    const label = btn.textContent;
    btn.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.gkUpsell, 10), quantity: 1 }] })
    })
      .then((r) => { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(() => { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
      .catch(() => {
        btn.textContent = 'Nochmal versuchen';
        btn.removeAttribute('aria-busy');
        setTimeout(() => { btn.textContent = label; }, 2500);
      });
  });

  /* ---------- 3. Tidio: Hinweistext ausblenden ---------- */
  const TIDIO_CSS = '[data-testid="widgetLabel"]{display:none!important}';
  const patchTidio = () => {
    const host = document.getElementById('tidio-chat');
    const root = host && host.shadowRoot;
    if (!root || root.getElementById('gk-tidio-css')) return;
    const st = document.createElement('style');
    st.id = 'gk-tidio-css';
    st.textContent = TIDIO_CSS;
    root.appendChild(st);
  };

  /* ---------- Start + nach jedem Neuaufbau des Drawers ---------- */
  const run = () => { renderDelivery(); patchTidio(); };
  let t = null;
  new MutationObserver(() => { if (t) return; t = setTimeout(() => { t = null; run(); }, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
